import React, { FC, useEffect, useState } from 'react';
import { Button, Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { EFormFieldMessage } from 'common/const/form.enum';
import { EPlaceholder } from 'common/const/placeholder.enum';
import { ERoute } from 'common/const/route.enum';
import { rules } from 'common/helpers/form.helper';
import { useCaptcha } from 'common/hooks/useCaptcha';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
import { RestoreSuccessCard } from 'entities/Auth/components/Restore/RestoreSuccessCard';
import { RestorePasswordCard } from 'entities/Auth/components/Restore/RestorePasswordCard';
import { AuthCardLogo } from 'entities/Auth/components/AuthCardLogo';
import { AuthCardFooter } from 'entities/Auth/components/AuthCardFooter';
import { selectAuthError, sendRestorePasswordEmail, setAuthError } from 'entities/Auth/Auth.slice';

export const RestorePage: FC = () => {
  const dispatch = useAppDispatch();
  // auth
  const authError = useAppSelector(selectAuthError);

  const [email, setEmail] = useState<string>('');
  const [showSuccessCard, setShowSuccessCard] = useState<boolean>(false);
  const [form] = useForm();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { trigger, loading, captchaNode } = useCaptcha();

  useEffect(() => {
    if (authError) {
      form.setFields([{ name: 'email', errors: [authError] }]);
    }
  }, [authError]);

  const hash = searchParams.get('hash');

  const handleSendRestorePasswordEmail = async (emailValue: string): Promise<void> => {
    dispatch(setAuthError(null));

    await dispatch(
      sendRestorePasswordEmail({
        email: emailValue,
        onSuccess: () => {
          setEmail(emailValue);
          setShowSuccessCard(true);
        },
      }),
    );
  };

  const handleSubmit = (values: { email?: string }): void => {
    dispatch(setAuthError(null));
    trigger(() => handleSendRestorePasswordEmail(values.email as string));
  };

  if (hash) {
    return <RestorePasswordCard hash={hash} />;
  }

  if (showSuccessCard) {
    return <RestoreSuccessCard email={email} />;
  }

  return (
    <div className="auth-card">
      <AuthCardLogo />

      <div className="auth-card__content">
        <Form className="auth-card__content-form" form={form} layout="vertical" requiredMark={false} onFinish={handleSubmit}>
          <div className="mb-11 auth-card__content-form-title">Восстановление пароля</div>

          <Form.Item
            className="w-100 mb-11"
            label="Ваша почта*"
            name="email"
            rules={[rules.required(true, 'Обязательное поле'), rules.type('email', EFormFieldMessage.InvalidEmailFormat)]}
          >
            <Input placeholder={EPlaceholder.EnterEmailAddress} />
          </Form.Item>

          {captchaNode}

          <div className="auth-card__content-btn-container">
            <Button className="button-lg secondary w-100" loading={loading} onClick={() => navigate(ERoute.Login)}>
              Отмена
            </Button>

            <Button className="button-lg primary w-100" loading={loading} htmlType="submit">
              Восстановить
            </Button>
          </div>
        </Form>
      </div>

      <AuthCardFooter content="СПРАУТ. Система управления закупками." />
    </div>
  );
};
